import React from "react";
import { motion } from "framer-motion";
import { TrendingUp, TrendingDown } from "lucide-react";

export default function EngineStatCard({
  title,
  value,
  subtitle,
  trend,
  trendType = "neutral",
  icon: Icon,
  iconColor = "bg-sky-100 text-sky-600",
  delay = 0,
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay }}
      className="bg-white rounded-2xl p-5 shadow-sm border border-slate-100 hover:shadow-md transition-shadow"
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm text-slate-500 font-medium">{title}</p>
          <p className="text-2xl font-bold text-slate-900 mt-1">{value}</p>
          {subtitle && (
            <p className="text-xs text-slate-400 mt-1">{subtitle}</p>
          )}
          {trend && (
            <div className={`flex items-center gap-1 mt-2 text-sm ${
              trendType === "positive" ? "text-emerald-600" :
              trendType === "negative" ? "text-red-600" : "text-slate-500"
            }`}>
              {trendType === "positive" ? (
                <TrendingUp className="h-3.5 w-3.5" />
              ) : trendType === "negative" ? (
                <TrendingDown className="h-3.5 w-3.5" />
              ) : null}
              <span>{trend}</span>
            </div>
          )}
        </div>
        {Icon && (
          <div className={`w-12 h-12 rounded-xl ${iconColor} flex items-center justify-center`}>
            <Icon className="h-6 w-6" />
          </div>
        )}
      </div>
    </motion.div>
  );
}